module.exports = __webpack_public_path__ + "img/2_smoke.1925c9a8.png";